const firebaseConfig = {
    apiKey: "AIzaSyCn29YR7zHZf2HJN0j_I-3VBHxK3uzgGgQ",
    authDomain: "volunteer-5d7fb.firebaseapp.com",
    databaseURL: "https://volunteer-5d7fb.firebaseio.com",
    projectId: "volunteer-5d7fb",
    storageBucket: "volunteer-5d7fb.appspot.com",
    messagingSenderId: "4429134017",
    appId: "1:4429134017:web:6c799a0cf03f445b703c40"
  };

  export default firebaseConfig;